import filePreviewImageTemplate from './file-preview-image.html';

export default class FilePreviewPdfComponent {
  constructor() {
    this.template = filePreviewImageTemplate;
    this.bindings = {
      imageUrl: '<',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/file-preview/components/file-preview-image/file-preview-image-component.js